import React, {useEffect} from 'react'
import {useNavigate} from 'react-router'
import PropTypes from 'prop-types'
import {Box, Flex} from '@chakra-ui/react'

import {SMALL_SCREEN_BREAKPOINT} from './constants'
import {PayablePropType} from '../../propTypes'
import FormPanel from './FormPanel'
import PayableContentPanel from './PayableContentPanel'
import {SuccessScreen} from './SuccessScreen'

export const PaymentWizard = ({payable, reloadPayable, isLoading}) => {
  const navigate = useNavigate()

  const [showSuccess, setShowSuccess] = React.useState(false)
  const [successfulPaymentAmount, setSuccessfulPaymentAmount] =
    React.useState(null)

  const handlePaymentSuccess = (paymentAmount) => {
    setSuccessfulPaymentAmount(paymentAmount)
    setShowSuccess(true)
  }

  useEffect(() => {
    if (!payable) return

    if (!payable.canPay && payable.lifecycleStatus === 'eligible') {
      // If the status is eligible but something else is preventing the payable from being paid
      // Redirect to the bills page
      navigate('/points_on_payments/bills')
    }
  }, [payable, navigate])

  if (showSuccess && successfulPaymentAmount) {
    return <SuccessScreen paymentAmount={successfulPaymentAmount} />
  }

  return (
    <Flex
      height={{base: '100%', [SMALL_SCREEN_BREAKPOINT]: 'calc(100vh - 65px)'}}
      justify="center"
      flexWrap={{base: 'wrap', [SMALL_SCREEN_BREAKPOINT]: 'nowrap'}}
    >
      <Box
        backgroundColor="white"
        width="100%"
        maxW="1000px"
        borderRadius="lg"
        // Using margin here rather than a parent gap to ensure the form panel has enough padding for the box shadows on its inner panels.
        my={{base: 'sm', [SMALL_SCREEN_BREAKPOINT]: 'md'}}
        mt={{base: 'sm', [SMALL_SCREEN_BREAKPOINT]: 'md'}}
        ml="md"
        mx={{base: 'sm', [SMALL_SCREEN_BREAKPOINT]: 'md'}}
        p={{base: 'sm', [SMALL_SCREEN_BREAKPOINT]: 'md'}}
      >
        <PayableContentPanel
          payable={payable}
          reloadPayable={reloadPayable}
          isLoading={isLoading}
        />
      </Box>
      <Box
        width="100%"
        maxW={{base: 'auto', [SMALL_SCREEN_BREAKPOINT]: '500px'}}
        overflowY="auto"
        // Using padding here rather than a parent gap to ensure the form panel has enough padding for the box shadows on its inner panels.
        p={{base: 'sm', [SMALL_SCREEN_BREAKPOINT]: 'md'}}
        pt={{base: '0', [SMALL_SCREEN_BREAKPOINT]: 'md'}}
      >
        <FormPanel
          payable={payable}
          reloadPayable={reloadPayable}
          isLoading={isLoading}
          onSuccess={handlePaymentSuccess}
        />
      </Box>
    </Flex>
  )
}

PaymentWizard.defaultProps = {
  payable: null,
  reloadPayable: () => {},
}

PaymentWizard.propTypes = {
  payable: PayablePropType,
  reloadPayable: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
}
